export default "__VITE_ASSET__BU2Jpx$t__"